import React from 'react';

// omzo-style stage stepper, e.g. Start → Preliminary → Health → Details →
// Eligibility. `stages` come from the flow definition; `active` is the index
// of the stage the current question belongs to.
const PreviewProgress = ({ stages = [], active = 0 }) => (
  <nav className="flex items-center w-full" aria-label="Progress" data-testid="preview-progress">
    {stages.map((label, i) => {
      const state = i < active ? 'is-done' : i === active ? 'is-active' : '';
      return (
        <React.Fragment key={label}>
          <div className={`wl-stage flex items-center gap-2 ${state}`} aria-current={i === active ? 'step' : undefined} data-testid={`stage-${i}`}>
            <span className="wl-stage-dot" aria-hidden="true">
              {i < active ? (
                <svg className="w-3 h-3 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="3"><path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" /></svg>
              ) : null}
            </span>
            <span className={`text-sm font-medium ${i === active ? '' : 'hidden sm:inline'}`}>{label}</span>
          </div>
          {i < stages.length - 1 && <span className={`wl-stage-line mx-2 ${i < active ? 'is-done' : ''}`} aria-hidden="true" />}
        </React.Fragment>
      );
    })}
  </nav>
);

export default PreviewProgress;
